import { render } from "./HandPointing.vue?vue&type=template&id=7242a922"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/HandPointing.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7242a922"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7242a922', __exports__)) {
    api.reload('7242a922', __exports__)
  }
  
  module.hot.accept("./HandPointing.vue?vue&type=template&id=7242a922", () => {
    api.rerender('7242a922', render)
  })

}


export default __exports__